import { useCallback, useRef, useEffect } from 'react';
import { useChatHistory } from './parts/chat/useChatHistory';
import { useChatSession } from './parts/chat/useChatSession';

/**
 * AI 채팅 서비스의 통합 훅.
 * 채팅 내역(보조)과 활성 채팅 세션(주액션)을 결합하여 제공합니다.
 * 
 */
export const useChat = (currentUser = {}, viewMode = 'personal') => {
    
    // 1. 채팅 내역 관리 (historyList, fetchHistoryList)
    const { 
        historyList, 
        isHistoryLoading,
        fetchHistoryList: baseFetchHistoryList 
    } = useChatHistory(currentUser);

    // viewMode를 ref로 보관하여 sendMessage 내부 성공 시 콜백에서 최신값 사용
    const viewModeRef = useRef(viewMode);
    useEffect(() => { viewModeRef.current = viewMode; }, [viewMode]);

    const handleSuccessCallback = useCallback(() => {
        baseFetchHistoryList(currentUser.id, viewModeRef.current);
    }, [baseFetchHistoryList, currentUser.id]);

    // 2. 활성 채팅 세션 관리 (messages, isAiTyping, sendMessage, startNewChat)
    const { 
        messages, 
        isAiTyping, 
        isSessionLoading,
        sendMessage, 
        startNewChat 
    } = useChatSession(currentUser, handleSuccessCallback);

    // 이전과 동일한 API 구조 유지를 위한 랩퍼 (fetchHistoryList 노출)
    const fetchHistoryList = useCallback((memberId, mode = 'personal') => {
        baseFetchHistoryList(memberId, mode);
    }, [baseFetchHistoryList]);

    return { 
        messages, 
        isAiTyping, 
        isSessionLoading,
        sendMessage, 
        historyList, 
        isHistoryLoading,
        fetchHistoryList, 
        startNewChat 
    };
};
